import React, { useState } from "react";
import Image from "next/image";
import { testimonialsTwoFour } from "data/testimonials"; // Importing data from the provided path

export default function TestimonialsFour() {
  const [selectedTestimonial, setSelectedTestimonial] = useState(0); // Default to the first testimonial

  const handleSlideChange = (index) => {
    setSelectedTestimonial(index); // Change the selected testimonial on image click
  };

  return (
    <section className="testimonial-section-four">
      <div className="testimonial-container-four">
        {/* Header Section */}
        <div className="testimonial-header-four">
          <h2 className="testimonial-title-four text-[#140342]">
            Results That
            <span className="testimonial-highlight-four"> Matter </span>
          </h2>
          <p className="testimonial-subtitle-four">
            Top NEET Achievers: Backed by Our Proven Success!{" "}
          </p>
        </div>

        {/* Testimonial Navigation - Circular Images */}
        <div className="testimonial-nav-four">
          {testimonialsTwoFour.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`testimonial-nav-item-four ${
                selectedTestimonial === index ? "testimonial-active-four" : ""
              }`}
              onClick={() => handleSlideChange(index)}
            >
              <Image
                src={testimonial.image.startsWith('/') ? testimonial.image : `/${testimonial.image}`}
                alt={testimonial.name}
                width={80}
                height={80}
                loading="lazy"
                className="testimonial-nav-image-four"
                sizes="(max-width: 80px) 100vw, 80px"
                priority={false}
                unoptimized={testimonial.image.startsWith('http')}
              />
            </div>
          ))}
        </div>

        {/* Testimonial Content Section */}
        <div className="testimonial-content-container-four">
          {/* Testimonial Image */}
          <div className="testimonial-image-four hidden-on-768">
            <Image
              src={testimonialsTwoFour[selectedTestimonial].image.startsWith('/') ? testimonialsTwoFour[selectedTestimonial].image : `/${testimonialsTwoFour[selectedTestimonial].image}`}
              alt={testimonialsTwoFour[selectedTestimonial].name}
              width={261}
              height={300}
              className="testimonial-large-image-four"
              sizes="(max-width: 261px) 100vw, 261px"
              priority={false}
              unoptimized={testimonialsTwoFour[selectedTestimonial].image.startsWith('http')}
            />
          </div>

          {/* Testimonial Text */}
          <div className="testimonial-text-content-four">
            <p className="testimonial-text-four text-justify">
              {testimonialsTwoFour[selectedTestimonial].text}
            </p>
            <p className="testimonial-name-four">
              - {testimonialsTwoFour[selectedTestimonial].name}
            </p>
            <p className="testimonial-profession-four">
              {testimonialsTwoFour[selectedTestimonial].profession}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
